import { styled } from '@clickcease/cc-client-components-lib'

export const CrossSellPricingStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const CrossSellPricingHeader = styled('div', {
  width: '100%',
  height: '154px',
  background: '#EEF1FA',
  lineHeight: '154px',
  textAlign: 'center',
  fontSize: '$hxl',
  fontWeight: '$b',
})

export const CrossSellPricingMain = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
})

export const CrossSellPricingUpTo = styled('div', {
  width: '100%',
  display: 'flex',
  margin: '0px 0px $8 0px',
})

export const CrossSellSliderWrapper = styled('div', {
  marginBottom: '0px',
})

export const CrossSellPricingWrapper = styled('div', {
  display: 'flex',
  background: '$white',
  padding: '$16 3% ',
  borderBottomRightRadius: '12px',
  borderBottomLeftRadius: '12px',

  '@laptop': {
    padding: '$16 2% ',
  },
})

export const CrossSellShowHideFeaturesList = styled('div', {
  color: '$primaryColor',
  fontSize: '$h4',
  fontWeight: '$sb',
  margin: '64px 0px 40px 0px',
  cursor: 'pointer',
})

export const CrossSellPricingTableHeader = styled('div', {
  display: 'flex',
  marginRight: '30px',
  '@laptop': {
    marginRight: '0px',
  },
})

export const CrossSellPricingTableHeaderTitle = styled('div', {
  fontWeight: '$sb',
  fontSize: '$hxl',
  width: '416px',
  marginBottom: '32px',
})

export const CrossSellPricingTableHeaderPlans = styled('div', {
  display: 'flex',
})

export const CrossSellPricingTableStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const CrossSellPricingTableHeaderPlan = styled('div', {
  color: '$black',
  fontSize: '$lg',
  fontWeight: '$sb',
  lineHeight: '64px',
  textAlign: 'center',
  width: '230px',
})

export const CrossSellPricingTableHeaderSeparator = styled('div', {
  background: '$veryLightGray',
  height: '64px',
  width: '1px',
})
